

export default function TickShieldIcon (){
    return(
        <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                aria-label="Verified host"
                role="img"
                focusable="false"
                style={{
                  display: "block",
                  height: "16px",
                  width: "16px",
                  fill: "white",
                }} 
              >
                <path d="m16 .8.56.37C20.4 3.73 24.2 5 28 5h1v12.5C29 25.57 23.21 31 16 31S3 25.57 3 17.5V5h1c3.8 0 7.6-1.27 11.45-3.83L16 .8zm7 9.08-9.5 9.5-4.5-4.5L6.88 17l6.62 6.62L25.12 12 23 9.88z"></path>
              </svg>
    )
}